module.exports = __webpack_public_path__ + "media/images/front/icon_recommend_01-14465c928d7b146aa6ad0a6c145b1184.svg";